<template>
  <div class="carousel-container">
    <div class="carousel-wrapper">
      <div
        v-for="(image, index) in images"
        :key="index"
        :class="['carousel-slide', { active: index === currentIndex }]"
      >
        <img :src="image" alt="Service Slide" class="carousel-image" />
      </div>
      <button class="carousel-control left" @click="prevSlide">‹</button>
      <button class="carousel-control right" @click="nextSlide">›</button>
    </div>
  </div>
</template>

<script>
export default {
  name: "ServiceCarousel",
  props: {
    images: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      currentIndex: 0,
    };
  },
  methods: {
    nextSlide() {
      this.currentIndex = (this.currentIndex + 1) % this.images.length;
    },
    prevSlide() {
      this.currentIndex =
        (this.currentIndex - 1 + this.images.length) % this.images.length;
    },
  },
  mounted() {
    setInterval(this.nextSlide, 3000);
  },
};
</script>

<style scoped>
.carousel-container {
  position: relative;
  width: 100%;
  height: 100vh ;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

.carousel-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
}

.carousel-slide {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  transition: opacity 0.5s ease-in-out;
}

.carousel-slide.active {
  opacity: 1;
}

.carousel-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.carousel-control {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background-color: rgba(0, 0, 0, 0.5);
  color: rgb(235, 25, 25);
  border: none;
  border-radius: 50%;
  font-size: 1.5rem;
  width: 40px;
  height: 40px;
  cursor: pointer;
  z-index: 10;
}

.carousel-control.left {
  left: 10px;
}

.carousel-control.right {
  right: 10px;
}
</style>
